import { mainColor2 } from "../theme";

const notificationsStyles = {
  notificationBody: {
    width: 400,
    maxHeight: 400,
    overflowY: "auto",
  },
  notiHeader: {
    marginTop: "-12px",
    marginBottom: "-12px",
    padding: "12px 0",
    background: mainColor2,
  },
};

export default notificationsStyles;
